module.exports = __webpack_public_path__ + "static/media/PastLife_webp_border.e02228b5.webp";